import { AsyncZipDeflate } from "fflate";

/**
 * Streams data from a ReadableStream reader into a ZIP entry.
 * Reads chunks from `reader` and pushes them into `zipEntry`.
 * Marks the entry as complete when the stream ends.
 */
export async function pipeResponseBodyToZipEntry(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  zipEntry: AsyncZipDeflate,
): Promise<void> {
  let done = false;

  while (!done) {
    const { done: streamDone, value } = await reader.read();
    done = streamDone;
    if (value) zipEntry.push(value);
  }

  zipEntry.push(new Uint8Array(0), true); // finalize entry
}
